export const DREAM_MAT_BENNETT = 'dreamMatBennett'
export const DREAM_MAT_ODIN = 'dreamMatOdin'
export const DREAM_STAIRS = 'dreamStairs'
export const DREAM_GATE = 'dreamGate'
export const DREAM_RICKSHAW = 'dreamRickshaw'
export const DREAM_SHORE = 'dreamShore'
export const DREAM_BUOY = 'dreamBuoy'
export const DREAM_DEPTHS = 'dreamDepths'
export const DREAM_OCEAN_FLOOR = 'dreamOceanFloor'
export const DRIVING_BACKDROP = 'drivingBackdrop'
export const ESTHER_SPEECH = 'estherSpeech'
export const GOLDEN_GATE_BACKDROP = 'goldenGateBackdrop'
export const LOS_ANGELES_BACKDROP = 'losAngelesBackdrop'
export const MOUNTAIN_PAMPAS_BACKDROP = 'mountainPampasBackdrop'
export const MOUNTAIN_TAIWAN_BACKDROP = 'mountainTaiwanBackdrop'
export const OAKLAND_FRONT = 'oaklandFront'
export const OAKLAND_FRONT__HIGH = 'oaklandFront__high'
export const OAKLAND_FRONT__LOW = 'oaklandFront__low'
export const OAKLAND_SIDE = 'oaklandSide'
export const OAKLAND_SIDE__LEVEL = 'oaklandSide__level'
export const OAKLAND_SIDE__LIZ_COUCH = 'oaklandSide__lizCouch'
export const OCEAN_DEPTHS_VOLCANOES = 'oceanDepthsVolcanoes'
export const OCEAN_FLOOR_VOLCANOES = 'oceanFloorVolcanoes'
export const OCEAN_WAVES = 'oceanWaves'
export const OCEAN_WAVES__FRONT = 'oceanWaves__front'
export const OCEAN_WAVES__REAR = 'oceanWaves__rear'
export const PHARMACY_CEL = 'pharmacyCel'
export const ROAD_FUTURE = 'roadFuture'
export const ROAD_PAST = 'roadPast'
export const ROAD_PRESENT = 'roadPresent'
export const SHORE_BUOY_BACKDROP = 'shoreBuoyBackdrop'
export const SHORE_RICKSHAW_BACKDROP = 'shoreRickshawBackdrop'
export const TAIWAN_MOUNTAINS_BACKDROP = 'taiwanMountainsBackdrop'
export const TAIWAN_STAIRS_BACKDROP = 'taiwanStairsBackdrop'
export const THEATRE_SEATS_BACKDROP = 'theatreSeatsBackdrop'
export const THOUGHT_LARGE = 'thoughtLarge'
export const THOUGHT_LARGE__LEFT = 'thoughtLarge__left'
export const THOUGHT_LARGE__RIGHT = 'thoughtLarge__right'
export const THOUGHT_MEDIUM = 'thoughtMedium'
export const THOUGHT_SMALL = 'thoughtSmall'
export const VALLEY_CLOSER_BACKDROP = 'valleyCloserBackdrop'
export const VALLEY_FURTHER_BACKDROP = 'valleyFurtherBackdrop'
export const VALLEY_PANORAMA_BACKDROP = 'valleyPanoramaBackdrop'
export const WEDDING_BACKDROP = 'weddingBackdrop'
